<template>
  <div class="user_archive_list">
    <span>{{ $t('meta_title.user.archive.list') }}</span>
    <router-link-guard :to="{ name: 'UserList'}" :msg_slug="'meta_title.user.list'" :authorization="'user_index'"/>
    <hr>
    <span>{{ $t('utils.item_limit') }}</span>
    <select v-model="limit">
      <option v-for="limit in limits_options" :value="limit">{{ limit }}</option>
    </select>

    <paginate
      v-model="page"
      :page-count="page_count"
      :prev-text="'&laquo;'"
      :next-text="'&raquo;'"
      :hide-prev-next="hide_prev_next"
      :click-handler="refreshUsersByPage"
      :container-class="'pagination'"
      :page-class="'page-item'"
      :prev-class="'page-item'"
      :next-class="'page-item'"
      :page-link-class="'page-link'"
      :prev-link-class="'page-link'"
      :next-link-class="'page-link'">
    </paginate>

    <ul v-if="users && users.length">
      <li v-for="user in users">
        <p><strong>{{user.firstname}}</strong></p>
        <p>{{user.lastname}}</p>
        <p>{{user.role}}</p>
        <router-link-guard :to="{ name: 'UserShowArchive', params: { id: user.id }}" :msg_slug="'action.show'" :authorization="'user_show'"/>
        <router-link-guard :to="{ name: 'UserEditArchive', params: { id: user.id }}" :msg_slug="'action.archive.restore'" :authorization="'user_archive'"/>
        <router-link-guard :to="{ name: 'UserDeleteArchive', params: { id: user.id }}" :msg_slug="'action.archive.destruct'" :authorization="'user_archive'"/>
      </li>
    </ul>

    <paginate
      v-model="page"
      :page-count="page_count"
      :prev-text="'&laquo;'"
      :next-text="'&raquo;'"
      :hide-prev-next="hide_prev_next"
      :click-handler="refreshUsersByPage"
      :container-class="'pagination'"
      :page-class="'page-item'"
      :prev-class="'page-item'"
      :next-class="'page-item'"
      :page-link-class="'page-link'"
      :prev-link-class="'page-link'"
      :next-link-class="'page-link'">
    </paginate>
  </div>
</template>

<script>
  export default {
    name: 'UserListArchive',
    data() {
      return {
        users: [],
        page: 1,
        limits_options: [10, 20, 50, 100, 250, 500],
        limit: 20,
        total: 0,
        hide_prev_next: false,
      }
    },
    computed: {
      page_count(){
        let count = this.total / this.limit

        // Make the symbols disappear if no page choice
        this.hide_prev_next = !count || count <= 1

        return count && count > 1 ? count : 0
      }
    },
    watch: {
      limit(newLimit, oldLimit){
        // Go to the page where the first item of the old page is displayed
        this.page = Math.ceil(((this.page - 1) * oldLimit + 1) / this.limit)
        this.getUsers()
      }
    },
    methods: {
      getParams(){
        // Initialize return
        let _return = '?'

        // Set different params
        if(this.page > 1)
          _return += 'page=' + this.page + '&'
        if(this.limit > 2)
          _return += 'limit=' + this.limit + '&'

        // Remove the trailing "&"
        _return = _return.slice(0, -1)

        // If no params defined, go back to empty
        if(_return === '?')
          _return = ''

        return _return
      },
      getUsers(){
        this.$http.get(`user/archive` + this.getParams())
          .then(response => {

            // Custom response and redirection if no archives
            if(response.status === 204){
              this.$toastr.error(this.$i18n.t('error.user.empty_archive'))
              this.$router.push({name: 'UserList'})
            }

            this.users = response.data.users
            this.total = response.data.total
          })
      },
      refreshUsersByPage(pageNum){
        this.page = pageNum
        this.getUsers()
      }
    },
    created() {
      this.getUsers()
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/list_archive.vue